<template>
  <div class="mt-3" v-if="items && items.length > 0">
    <h6 class="mb-2">Bitacora de validacion</h6>
    <CDataTable
      :items="items"
      :fields="fields"
      :items-per-page="50"
      pagination
      small
      bordered
      striped
      hover
      style="font-size: 12px;"
    >
      <template #row="{ item }">
        <td class="text-center">{{ item.row }}</td>
      </template>

      <template #status="{ item }">
        <td class="text-center">
          <CBadge v-if="item.status === 'valid'" color="success">Valido</CBadge>
          <CBadge v-else-if="item.status === 'warning'" color="warning">Advertencia</CBadge>
          <CBadge v-else-if="item.status === 'ignored'" color="info">Ignorado</CBadge>
          <CBadge v-else color="danger">Error</CBadge>
        </td>
      </template>

      <template #message="{ item }">
        <td>{{ item.message }}</td>
      </template>

      <template #suggested_action="{ item }">
        <td>{{ item.suggested_action || '-' }}</td>
      </template>
    </CDataTable>
  </div>
</template>

<script>
export default {
  name: 'ImportValidationLog',
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      fields: [
        { key: 'row', label: 'Fila', _style: 'width: 70px;' },
        { key: 'status', label: 'Estado', _style: 'width: 120px;' },
        { key: 'message', label: 'Mensaje' },
        { key: 'suggested_action', label: 'Accion sugerida' }
      ]
    }
  }
}
</script>
